import { createApp, onMounted } from 'vue'

const templates = document.querySelectorAll('template')
let scripts;

templates.forEach(template => {
	const styles = template.content.querySelectorAll('style')
	scripts = template.content.querySelectorAll('script')

	styles.forEach(style => document.head.appendChild(style))
	scripts.forEach(script => script.remove())
})

const App = createApp({
	setup() {
		onMounted(() => {
			const tables = document.querySelectorAll('table')

			tables.forEach(table => {
				let parent = table.closest('.table-responsive')

				if(!parent) {
					parent = document.createElement('div')

					parent.classList.add('table-responsive')

					table.insertAdjacentElement('afterend', parent)

					parent.appendChild(table)
				}
			})

			scripts.forEach(script => document.body.appendChild(script))
		})
	}
})

export const registraComponent = (selector, options) => {
	if (!selector) selector = options.name

	App.component(selector, options)
}

export const registraGlobalComponents = componentMapList => {
	for(const [name, options] of Object.entries(componentMapList)) {
		registraComponent(name, options)
	}
}

export default App
